module.exports = __webpack_public_path__ + "img/working-on-the-go.1d7ebbbe.jpg";